class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.home-hero__hamburger');
    this.panel = this.querySelector('.home-hero__mobile-panel');

    if (!this.button || !this.panel) return;

    this.button.addEventListener('click', this.toggle.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('keydown', this.onKeydown.bind(this));
  }

  toggle() {
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';
    isOpen ? this.close() : this.open();
  }

  open() {
    this.button.setAttribute('aria-expanded', 'true');
    this.panel.hidden = false;
    this.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.hidden = true;
    this.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  onDocumentClick(event) {
    if (this.button.getAttribute('aria-expanded') !== 'true') return;
    if (this.contains(event.target)) return;
    this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }
}

if (!customElements.get('mobile-menu-drawer')) {
  customElements.define('mobile-menu-drawer', MobileMenuDrawer);
}